export default __webpack_public_path__ + "static/media/blue.65d966e4.svg";